"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sortNumeric = function (a, b) { return a - b; };
exports.getSortedKeyframes = function (propertyGroup) {
    return Object.keys(propertyGroup).map(Number).sort(sortNumeric);
};
//# sourceMappingURL=KeyframeUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/helpers/KeyframeUtils.js
// module id = 59
// module chunks = 35783957827783 127651196306611 162898551421021